(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .factory('consultationService', consultationService);

  /* ngInject */
  function consultationService($resource, config) {
    let url = `${config.complianceServicesApiEndpoint}/api/message_threads`;
    let paramDefaults = {id: '@id'};
    let headers = authToken => ({'Authorization': 'Token token=' + authToken});
    let actions = authToken => ({
      'query': {
        method: 'GET', 
        isArray: false, 
        params: {visibility: 'fi', page: `@page`, status: `@status`, message_type: `@message_type`, updated_at: `@updated_at`}, 
        headers: headers(authToken)},
      'counts': {
        method: 'GET',
        isArray: false,
        url: `${url}/counts`,
        headers: headers(authToken)
      },
      'save': {method: 'POST', headers: headers(authToken)}
    });

    return authToken => $resource(url, paramDefaults, actions(authToken));
  }
})();
